import { Message } from "../../types";

let messageIdCounter = 0;

export const getUniqueMessageId = (): string => {
  messageIdCounter += 1;
  return `msg-${Date.now()}-${messageIdCounter}`;
};

export const createUserMessage = (content: string): Message => ({
  id: getUniqueMessageId(),
  role: "user",
  content,
  timestamp: new Date(),
});

export const createAssistantMessage = (
  content: string,
  downloadLink?: string,
  fileName?: string
): Message => ({
  id: getUniqueMessageId(),
  role: "assistant",
  content,
  timestamp: new Date(),
  ...(downloadLink && { downloadLink }),
  ...(fileName && { fileName }),
});

export const createSystemMessage = (content: string): Message => ({
  id: `system-${Date.now()}`,
  role: "assistant",
  content: `ℹ️ ${content}`,
  timestamp: new Date(),
});
